import {configureStore} from "@reduxjs/toolkit";
import documentReducer from "../pages/e-cap/IStoredDocumentRecordSlice";
import partnerRecordReducer from "../pages/e-cap/IStoredPartnerRecordSlice";
import ecapEntitlementPartnerReducer from "../pages/e-cap/IStoredEcapPartnerEntitlementSlice";
import rulesReducer from "../pages/e-cap/IStoredRulesSlice";
import draftDocumentLoadingReducer from "../pages/e-cap/IStoredDraftDocumentLoadingSlice";
import templateDocumentLoadingReducer from "../pages/e-cap/IStoredTemplateDocumentLoadingSlice";
import surveyReducer from "../pages/survey/IStoredSurveySlice"
import globalStateReducer from './IEDPGlobalSlice';
import documentOverviewReducer from "../pages/e-cap/IStoredDocumentOverviewSlice";
import missingInvoicesReducer from "../pages/e-cap/IStoredMissingInvoicesSlice";
import entitlementReducer from "../pages/dashboard/entitlement_maintenance/redux/IStoredEntitlementsSlice";
import masterDataReducer from "../pages/dashboard/MasterDateMaintenance/Redux/IStoredMasterDataSlice";
import chatbotReducer from './ChatbotSlice';
import eimDashboardFiltersReducer from '../pages/eim/dashboard/eimDashboardFiltersSlice';

export const store = configureStore({
  reducer: {
    document: documentReducer,
    documentOverview: documentOverviewReducer,
    missingInvoices: missingInvoicesReducer,
    partnerRecord: partnerRecordReducer,
    ecapEntitlementPartner: ecapEntitlementPartnerReducer,
    rules: rulesReducer,
    draftDocumentLoading: draftDocumentLoadingReducer,
    templateDocumentLoading: templateDocumentLoadingReducer,
    survey: surveyReducer,
    globalStateReducer,
    entitlements: entitlementReducer,
    masterDataReducer,
    chatbot: chatbotReducer,
    eimDashboardFilters: eimDashboardFiltersReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredPaths: ['rules.ruleMap', 'chatbot.messages.*.timestamp'],
      },
    }),
});

// Save chatbot state to localStorage whenever it changes
// BUT: Only save if there are real user messages (not just welcome animation messages)
store.subscribe(() => {
  try {
    const state = store.getState();
    // Filter out welcome animation messages (id '0' and '1') - only save real conversations
    const realMessages = state.chatbot.messages.filter((msg: any) => msg.id !== '0' && msg.id !== '1');
    
    // Only save to localStorage if there are real messages
    if (realMessages.length > 0) {
      const chatbotState = {
        ...state.chatbot,
        messages: realMessages.map((msg: any) => ({
          ...msg,
          timestamp: msg.timestamp instanceof Date ? msg.timestamp.toISOString() : msg.timestamp,
        })),
      };
      localStorage.setItem('chatbot_state', JSON.stringify(chatbotState));
    } else {
      // Clear localStorage if no real messages
      localStorage.removeItem('chatbot_state');
    }
  } catch (error) {
                                                                                                                                                                                                                                                                                                                                                                                                                                                           console.warn('Failed to save chatbot state to localStorage:', error);
  }
});

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>